var _path, _path2;
const _excluded = ["title", "titleId"];
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
function _objectWithoutProperties(e, t) { if (null == e) return {}; var o, r, i = _objectWithoutPropertiesLoose(e, t); if (Object.getOwnPropertySymbols) { var n = Object.getOwnPropertySymbols(e); for (r = 0; r < n.length; r++) o = n[r], -1 === t.indexOf(o) && {}.propertyIsEnumerable.call(e, o) && (i[o] = e[o]); } return i; }
function _objectWithoutPropertiesLoose(r, e) { if (null == r) return {}; var t = {}; for (var n in r) if ({}.hasOwnProperty.call(r, n)) { if (-1 !== e.indexOf(n)) continue; t[n] = r[n]; } return t; }
import * as React from "react";
function SvgFormOutlined(_ref, svgRef) {
  let {
      title,
      titleId
    } = _ref,
    props = _objectWithoutProperties(_ref, _excluded);
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 19,
    height: 18,
    viewBox: "0 0 19 18",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M16.2373 9H15.2529C15.1756 9 15.1123 9.06328 15.1123 9.14062V14.7656H3.58105V3.23438H9.20605C9.2834 3.23438 9.34668 3.17109 9.34668 3.09375V2.10938C9.34668 2.03203 9.2834 1.96875 9.20605 1.96875H2.87793C2.5668 1.96875 2.31543 2.22012 2.31543 2.53125V15.4688C2.31543 15.7799 2.5668 16.0312 2.87793 16.0312H15.8154C16.1266 16.0312 16.3779 15.7799 16.3779 15.4688V9.14062C16.3779 9.06328 16.3146 9 16.2373 9Z",
    fill: "#FF4B33"
  })), _path2 || (_path2 = /*#__PURE__*/React.createElement("path", {
    d: "M6.60275 9.40254L6.56935 11.4926C6.5676 11.649 6.69416 11.7773 6.8506 11.7773H6.85764L8.93185 11.7264C8.96701 11.7246 9.00217 11.7105 9.02678 11.6859L16.3375 4.39102C16.392 4.33652 16.392 4.24688 16.3375 4.19238L14.1526 2.00918C14.1244 1.98105 14.0893 1.96875 14.0524 1.96875C14.0154 1.96875 13.9803 1.98281 13.9522 2.00918L6.64318 9.3041C6.61779 9.33065 6.60335 9.36581 6.60275 9.40254ZM7.71896 9.81738L14.0524 3.49805L14.8469 4.29082L8.50998 10.6137L7.70666 10.633L7.71896 9.81738Z",
    fill: "#FF4B33"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgFormOutlined);
export default __webpack_public_path__ + "static/media/FormOutlined.4d19351eeabbc072734ec210d999d9e8.svg";
export { ForwardRef as ReactComponent };